export const downloadConfigurationRequest = () => ({
  method: 'GET',
  url: `/modules/permission-mgmt/xmlconfig`
})

export const uploadConfigurationRequest = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return { method: 'POST', url: `/modules/permission-mgmt/xmlconfig`, data: formData }
}

export const exportCustomersRequest = (ouName: string) => ({
  method: 'GET',
  url: `/modules/customers/export/${encodeURIComponent(ouName)}`
})

export const getCustomerExtractStatusRequest = (ouName: string) => ({
  method: 'GET',
  url: `/modules/customers/extracts/${encodeURIComponent(ouName)}/status`
})
